// extracted by css-extract-rspack-plugin
export default {"container":"_f609443e"};